import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../../../redux/reducers';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../../../types/analytics';
import { getFormId } from '../../../../../../../browser/services/formId';

interface ITrackPackageSelectParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  packageServiceId: EServiceId;
}

export const trackPackageSelect = (params: ITrackPackageSelectParams) => {
  const { analyticsOfferStatus, analyticsProduct, packageServiceId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: 'publication_pack',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        publication_type: packageServiceId,
        form_id: getFormId(),
      },
    },
  });
};
